export function canSubmit() {
	return (
		!!this.form.data.name &&
		this.form.data.visibility.products.length > 0 &&
		this.form.data.visibility.stage.length > 0 &&
		((this.form.data.visibility.status.length > 0 && this.selectedStagesHaveStatus()) ||
			(this.form.data.visibility.status.length == 0 && !this.selectedStagesHaveStatus())) &&
		this.form.data.file_id != 0 &&
		!this.fileUploadLoading
	)
}
